<template>
    <div class="email-template-filter-toolbar">
        <CommonFilterTool
            v-model="emailTemplateFilter"
            :keep-state-on-query-params="false"
            :filter-meta="filterMetas"
            :label-formatter="filterLabelFormatter"
            @addFilter="addFilter"
            :showClearAll="false && isClearAllEnabled()"
            @applyFilterTemplate="applyFilterTemplate"
            :filter-templates="getFilterTemplates()"
            :selected-filter-template="getSelectedFilterTemplateName()"
            :hide-filters="false && this.selectedCustomFilterTemplate !== 'custom'"
            :show-add-button="true"
            :required-filters="getRequiredBreakdowns()"
        >
            <template slot="extra">
                <slot name="extra" />
            </template>
        </CommonFilterTool>
    </div>
</template>

<script>
import CommonFilterTool from "../../Chatbot/pages/archive/CommonFilterTool.vue";
import { mapState } from "vuex";

export default {
    name: "EmailTemplateFilterToolbar",
    components: { CommonFilterTool },
    data() {
        return {
            emailTemplateFilter: [],
            filterMetas: [
                {
                    name: "name",
                    label: "Şablon Adı",
                    materialIcon: "title",
                    controlType: "input",
                    controlProps: {},
                    defaultValue: "",
                },
                {
                    name: "subject",
                    label: "Konu",
                    materialIcon: "subject",
                    controlType: "input",
                    controlProps: {},
                    defaultValue: "",
                },
                {
                    name: "category",
                    label: "Kategori",
                    materialIcon: "category",
                    controlType: "select",
                    options: () => [
                        { id: "marketing", label: "Pazarlama" },
                        { id: "operational", label: "Operasyonel" },
                        { id: "private", label: "Özel" },
                    ],
                    defaultValue: "",
                },
                {
                    name: "creator",
                    label: "Oluşturan",
                    materialIcon: "person",
                    controlType: "select",
                    options: () => this.users.map((user) => ({ id: user._id, label: user.name })),
                    defaultValue: "",
                },
                {
                    name: "dateRange",
                    label: "Tarih Aralığı",
                    materialIcon: "date_range",
                    controlType: "date-range-picker",
                    defaultValue: {
                        timeSelect: "custom",
                        startDate: null,
                        endDate: null,
                    },
                },
            ],
            selectedCustomFilterTemplate: "custom",
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
        }),
    },
    methods: {
        getRequiredBreakdowns() {
            const templates = this.getFilterTemplates();
            return templates.find((x) => x.name === this.selectedCustomFilterTemplate)?.requiredBreakdowns || [];
        },
        getFilterTemplates() {
            return [
                // Filtre şablonlarını burada tanımlayın
            ];
        },
        applyFilterTemplate(name) {
            // Filtre şablonunu uygulama işlemini burada gerçekleştirin
        },
        getSelectedFilterTemplateName() {
            // Seçili filtre şablonunun adını burada döndürün
        },
        isClearAllEnabled() {
            return this.emailTemplateFilter.length > 1;
        },
        addFilter(name, value, autoOpen = true) {
            // Filtre ekleme işlemini burada gerçekleştirin
        },
        removeFilter(name) {
            // Filtre kaldırma işlemini burada gerçekleştirin
        },
        filterLabelFormatter(name, value) {
            // Filtre etiketini biçimlendirme işlemini burada gerçekleştirin
        },
        isFilterExists(name) {
            return !!this.emailTemplateFilter.find((x) => x.name === name);
        },
    },
    watch: {
        emailTemplateFilter: {
            handler: function () {
                this.$emit("input", this.emailTemplateFilter);
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="scss">
.email-template-filter-toolbar {
    // Stil tanımlarını burada yapın
}
</style>
